function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_16",
  "data-name": "Path 16",
  d: "M30.039,5.185a14.936,14.936,0,0,0-20.724,0,14.043,14.043,0,0,0-.894,19.35l10.242,12a1.334,1.334,0,0,0,2.027,0l10.242-12a14.043,14.043,0,0,0-.894-19.35ZM19.677,23.669a8,8,0,1,1,8-8A8,8,0,0,1,19.677,23.669ZM33.013,41.006H6.342a1.375,1.375,0,0,1-1.334-1.654L7.675,28.683a1.371,1.371,0,1,1,2.667.64L8.049,38.338H31.306l-2.294-9.015a1.371,1.371,0,1,1,2.667-.64l2.667,10.669a1.325,1.325,0,0,1-1.334,1.654Z",
  transform: "translate(-4.976 -1.006)"
});

var SvgLocation = function SvgLocation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29.412,
    height: 40,
    viewBox: "0 0 29.412 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLocation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/location.6db03bbd.svg";
export { ForwardRef as ReactComponent };